var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.detailData.title))]),_c('p',{staticClass:"headerTran"},[_vm._v(" "+_vm._s(_vm.detailData.synopsis)+" ")]),_c('div',{ref:"imageContainer",staticClass:"parent-box",domProps:{"innerHTML":_vm._s(_vm.detailData.contents)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }